import { useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import MarqueeBar from "@/components/MarqueeBar";
import Manifesto from "@/components/Manifesto";
import Gallery from "@/components/Gallery";
import ProductDialog from "@/components/ProductDialog";
import Footer from "@/components/Footer";

export default function Home() {
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);

  const openProduct = (p) => {
    setActive(p);
    setOpen(true);
  };

  const scrollToGallery = () => {
    const el = document.getElementById("gallery");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="grain">
      <Nav />
      <main id="main">
        <Hero onOpenGallery={scrollToGallery} />
        <MarqueeBar />
        <Manifesto />
        <Gallery onOpen={openProduct} />
      </main>
      <Footer />
      <ProductDialog product={active} open={open} onOpenChange={setOpen} />
    </div>
  );
}
